import { conversations as actions } from '../actions'

export const initialState = {
  open: true,
  // threads: [exampleThread],
  threads: [],
  selectedThread: null,
  // selectedThread: exampleThread,
  creating: false,
  selectedContacts: [],
  loading: {
    contacts: false,
    // contacts: true,
    threads: false,
    messages: false
  }
}

export const updateConversations = fn => dispatch =>
  dispatch({
    type: actions.UPDATE_CONVERSATIONS,
    payload: fn
  })

const setSelectedThread = thread => dispatch =>
  dispatch({
    type: actions.SET_SELECTED_THREAD,
    payload: thread
  })

export const clearSelectedThreads = () => setSelectedThread(null)
